import {
  Cloud,
  Cog,
  Database,
  Globe,
  HardDrive,
  KeyRound,
  Layers,
  Monitor,
  Server,
  Smartphone,
  Zap,
  type LucideIcon,
} from 'lucide-react'

import type { ComponentKind } from '../types'

/**
 * Un ícono por `kind`.
 *
 * El color agrupa por familia (ver `types.ts`); el ícono desambigua adentro de
 * la familia. Una base de datos y un almacenamiento comparten color, pero nadie
 * los confunde viendo los íconos.
 */
export const KIND_ICON: Record<ComponentKind, LucideIcon> = {
  frontend: Monitor,
  mobile: Smartphone,
  backend: Server,
  worker: Cog,
  queue: Layers,
  database: Database,
  storage: HardDrive,
  cache: Zap,
  auth: KeyRound,
  cdn: Globe,
  external_service: Cloud,
}
